// extracted by mini-css-extract-plugin
export default {"titleRow":"styles_titleRow__PenhH","totalContestants":"styles_totalContestants__44+9H","fullScreen":"styles_fullScreen__ZI+wq","filterRow":"styles_filterRow__OCj2O"};